import { HttpClient } from '@angular/common/http';
import {  Component, OnDestroy, OnInit,Inject, ViewChild, OnChanges, DoCheck} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { TableEditBase } from '../../../_infrastructure/TableEdit/TableEditBase';
import { EffectivityMapComponent } from './effectivity-map.component';
import { isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { ControlContainer, NgForm, FormControl, NgControl, NgModel, AbstractControl } from '@angular/forms';
import { SubscriberInformationService } from '../../../_infrastructure/SubscriberInfo/SubscriberInformationService';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { DatePipe } from '@angular/common';
import DateHelpers from '../../../_infrastructure/DateHelpers';
import { WorkflowComponent } from '../../workflow.component';
import { StepDetailsService } from '../../../_infrastructure/StepDetailsService/StepDetailsService';
import * as _ from 'lodash';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { CommonDataService } from '../../../_infrastructure/CommonData/CommonDataService';
import { UtilsService } from '../../../_infrastructure/Utils/UtilsService';

@Component({
    selector: 'effectivity-table-edit',
    templateUrl: './effectivity-table-edit.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class EffectivityTableEditComponent extends TableEditBase<models.EffectivityEntryVM> implements OnInit, OnDestroy {

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.subscriberSituations)
  public subscriberSituations: models.DimensionVM[];
  @CommonData(DomainCodes.scheduleTypes)
  public scheduleTypes: models.DimensionVM[];
  @CommonData(DomainCodes.remunerationTypes)
  public remunerationTypes: models.DimensionVM[];
  

  public subscriber: models.SubscriberInformationVM;
  public isExSubscritor: boolean;

  public maxDate: Date = new Date();

  public minDate: Date;
  public maxStartDate: Date;
  public minEndDate: Date;
  public maxEndDate: Date;
  public dataCessacao: Date;

  public entities: any[];
  public parentWorkflow: WorkflowComponent;
  public origin: string;
  public professionalClass: string;
  public interpolatedWorkHoursFilled: boolean = false;

  public bonusList: models.DimensionVM[] = [];
  public bonusDescriptions = [];
  public bonusInDays: boolean = false;
  public bonusWithQuota: boolean = false;
  public breakList = [];
  public nextBreak;

  private mainSubscription: Subscription = new Subscription();
  constructor(@Inject(EffectivityMapComponent) private parent: Component, private subscriberinfoService: SubscriberInformationService,
    private modalService: ModalService, private datePipe: DatePipe, private stepDetailsService: StepDetailsService,
    private commonDataService: CommonDataService, private utilsService: UtilsService) {
    super(parent, modalService);

    this.stepDetailsService.workFlowCode.pipe(
      filter(el => el !== null && el !== undefined)
    )
    .subscribe(workflowCode => {
      this.isExSubscritor = (workflowCode.indexOf('PEDI008') == -1 && workflowCode.indexOf('PEDI005') == -1) ? false : true;
    });

    // resolve CommonData as of angular version 18 is broken
    const domainCodes: string[] = [
      DomainCodes.domains,
      DomainCodes.yesNo,
      DomainCodes.subscriberSituations,
      DomainCodes.scheduleTypes,
      DomainCodes.remunerationTypes,
    ];
    this.mainSubscription.add(
      this.commonDataService.getDomains(domainCodes).subscribe(results => {
        this.domains = this.utilsService.getDomainOfDomains(DomainCodes.domains, results).dimensions;
        this.yesNo = this.utilsService.getDomainOfDomains(DomainCodes.yesNo, results).dimensions;
        this.subscriberSituations = this.utilsService.getDomainOfDomains(DomainCodes.subscriberSituations, results).dimensions;
        this.scheduleTypes = this.utilsService.getDomainOfDomains(DomainCodes.scheduleTypes, results).dimensions;
        this.remunerationTypes = this.utilsService.getDomainOfDomains(DomainCodes.remunerationTypes, results).dimensions;
      })
    ); 
    
  }


  ngOnInit(): void {
    super.ngOnInit();


    this.subscriberinfoService.getCurrentSubscriber().subscribe((subscriber) => {
      this.subscriber = subscriber;
      var tempDate = new Date(subscriber.dateOfBirth);
      this.minDate = new Date(tempDate.setFullYear(tempDate.getFullYear() + 12));
    })

    if (this.checkSteps()) {
      this.professionalClass = this.parent['parentWorkflow'].workflowInstance.formData.StepSubscriberCGA['CGAPensionStatus']?.professionalCategoryCode;
    } else {
      this.professionalClass = this.parent['parentWorkflow'].workflowInstance.formData.StepSubscriberInfo['CGAPensionStatus']?.professionalCategoryCode;
    }

    if (this.isVersion2()) {
      this.minDate.setDate(this.minDate.getDate() + 1);
      this.dataCessacao = new Date(this.parent['parentWorkflow']?.['workflowInstance']?.['formData']?.['StepSubscriberCGA']?.['CGAPensionStatus']?.['dataCessacao']);
      this.maxStartDate = new Date();
      this.minEndDate = new Date();
      this.maxEndDate = new Date();

      if (!isNullOrUndefined(this.item.endDate)) {
        this.maxStartDate = new Date(this.item.endDate);
      }
      if (!isNullOrUndefined(this.item.startDate)) {
        this.minEndDate = new Date(this.item.startDate);
      }
      if (this.maxStartDate.toDateString() === new Date().toDateString()) {
        this.maxStartDate.setDate(this.maxStartDate.getDate() - 1);
      }
      
      if (this.isExSubscritor) {
        this.maxStartDate = _.cloneDeep(this.dataCessacao);
        //this.maxStartDate.setDate(this.maxStartDate.getDate() - 1);
      }
        
      

      this.entities = this.getEntities();
      this.getSubscriberSituations();
      this.isOverlappedWithLiquidityDate();
      this.getStaticBreaks();
      this.getDynamicBreaks();
      this.sortBreaks();

      if (this.parent['cardData'].effectivityList[this.parent['expandedRowIndex']]) {
        this.origin = this.parent['cardData'].effectivityList[this.parent['expandedRowIndex']]['origin'];
        //failsafe validator on hasDiscount type
        if (typeof this.parent['cardData'].effectivityList[this.parent['expandedRowIndex']]['hasDiscounts'] === 'boolean') this.parent['cardData'].effectivityList[this.parent['expandedRowIndex']]['hasDiscounts'] = String(this.parent['cardData'].effectivityList[this.parent['expandedRowIndex']]['hasDiscounts']);
        //
        Object.assign(this.item, this.parent['cardData'].effectivityList[this.parent['expandedRowIndex']]); //copies values and not references to save previous state
      } else {
        this.origin = 'PGP';
      }

      if (this.item.timeIncrease?.toString() == 'false') this.item.percentage = undefined;
      if (this.item.timeIncrease?.toString() == 'false') this.item.hasIncreasePercentage = this.item.timeIncrease;

      let hasMatchedEntity = false;
      switch (this.origin) {
        case 'CT':
          if (this.item.entityCode !== undefined) {
            for (let i = 0; i < this.entities.length; i++) {
              if (this.entities[i]['type'] === this.item['entityCode'] || this.entities[i]['value'] === this.item['entityCode']) {
                hasMatchedEntity = true;
              }
            }
            if (!hasMatchedEntity) {
              this.item['entity'] = 'Outra';
              this.item['entityCode'] = 'OUTRA';
              this.changedEntity();
            }
          } else {
            this.item.entity = undefined;
            this.changedEntity();
          }

          if (this.item.hasDiscounts === undefined) {
            this.item.hasDiscounts = true;
          }
          break;
        case 'AC':
          for (let i = 0; i < this.entities.length; i++) {
            if (this.entities[i]['type'] === this.item['entityCode'] || this.entities[i]['value'] === this.item['entityCode']) {
              hasMatchedEntity = true;
            }
          }
          if (!hasMatchedEntity) {
            this.item['entityCode'] = 'FA';
            this.item['entity'] = 'Forças Armadas - militar do Exército, Marinha e Força Aérea';
            this.changedEntity();
          }
          if (this.item.hasDiscounts === undefined) {
            this.item.hasDiscounts = false;
          }
          if (this.item.timeIncrease?.toString() == 'false') {
            this.item.bonus = undefined;
            this.bonusOnChange(this.item.bonus);
          }
          break;
        case 'ICE':
          for (let i = 0; i < this.entities.length; i++) {
            if (this.entities[i]['description'] === this.item?.['entity'] || this.entities[i]['value'] === this.item['entityCode']) {
              if (!this.item.entityCode) this.item.entityCode = this.entities[i]['type'];
              hasMatchedEntity = true;
            }
          }
          if (!hasMatchedEntity) {
            this.item.entity = 'Outra';
            this.item.entityCode = "OUTRA";
            this.item.otherEntity = this.parent['cardData'].effectivityList[this.parent['expandedRowIndex']].otherEntity;
            this.changedEntity();
          }
          break;
        default:
      }
    }
    this.getBonus();
    this.bonusOnChange(this.item.bonus);

    if (this.isVersion2()) {
      this.changedStartDate();
      if (this.item.endDate > this.maxEndDate) {
        this.item.endDate = this.maxEndDate;
      }

      if (this.item['entityCode'] !== undefined) {
        this.getSubscriberSituations();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.mainSubscription) {
      this.mainSubscription.unsubscribe();
    }
  }

  isVersion2() {
    let result = false;
    if (this.parent['parentWorkflow']?.['workflowVersion']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  checkSteps() {
    let result = false;
    for (let i = 0; i < this.parent['parentWorkflow'].steps.length; i++) {
      if (this.parent['parentWorkflow'].steps[i].stepCode === "StepSubscriberCGA") {
        result = true;
        break;
      }
    }
    return result;
  }

  isOverlappedWithLiquidityDate() {
    let result = false;
    for (let i = 0; i < this.parent['cardData']['dividasLiquidadas']?.length ; i++) {
      if (this.parent['cardData']['dividasLiquidadas'][i].startDayLiq <= this.item.startDate && this.parent['cardData']['dividasLiquidadas'][i].endDateLiq >= this.item.endDate) {
        result = true;
      }
    }
    return result;
  }

  startAndEndDateValidator(event:any) {
    if (this.item.startDate?.getTime() !== this.parent['cardData'].effectivityList[this.parent['expandedRowIndex']]?.['startDate']?.getTime() || this.item.endDate?.getTime() !== this.parent['cardData'].effectivityList[this.parent['expandedRowIndex']]?.['endDate']?.getTime()) {
      this.item.value = undefined;
    }
  }

  changedStartDate() {
    this.nextBreak = undefined;
    this.minEndDate = new Date(this.item.startDate);

    for (let i = 0; i < this.breakList.length; i++) {
      if (this.breakList[i]['value'] > this.item.startDate) {
        this.nextBreak = new Object(this.breakList[i]);
        break;
      }
    }
    if (this.nextBreak !== undefined) {
      if (this.nextBreak['type'] === 'INI') {
        this.maxEndDate = new Date(this.nextBreak['value']);
        this.maxEndDate.setDate(this.maxEndDate.getDate() - 1)
      } else if (this.nextBreak['type'] === 'END') {
        this.maxEndDate = new Date(this.nextBreak['value']);
      }
    } else {
      this.maxEndDate = this.isExSubscritor ? this.dataCessacao : new Date();
    }

    
    /*if (this.isExSubscritor && this.dataCessacao < this.maxEndDate) {
      this.maxEndDate = _.cloneDeep(this.dataCessacao);
      this.maxEndDate.setDate(this.maxEndDate.getDate());
    }*/

    this.isOverlappedWithLiquidityDate();
  }

  isFA_Entity() {
    return this.item['origin'] == 'AC' && (this.item.entityCode == 'FA' || this.item.entityCode=='11');
  }
  getTimeIncrease(): boolean {
    return this.item.timeIncrease && this.item.timeIncrease?.toString() == 'true';
  }
  getHasIncreasePercentage(): boolean {
    return this.item.hasIncreasePercentage && this.item.hasIncreasePercentage?.toString() == 'true';
  }
  getNumberOfDaysInRange(): number {
    var start = new Date(this.item.startDate);
    var end = new Date(this.item.endDate);
    // +1 so the range is inclusive
    return Math.floor((end.getTime() - start.getTime()) / (1000 * 3600 * 24)) + 1;
  }

  isDate = function (date: string) {
    return (new Date(date).toString() !== "Invalid Date") && !isNaN(new Date(date).getTime());
  }

  getRangeLegth(): string {
    var rangeAsString = this.getNumberOfDaysInRange()?.toString();
    if (isNullOrUndefined(rangeAsString))
      return "0";
    else
      return rangeAsString.length.toString();
  }

  onEdit(isEdit: boolean) {
    super.markTouched();

    if (this.hasOverlapingDates() && this.tableItemEditForm.valid ) {
      var baseModal = <models.BaseModalVM>{ isError: false, message: "Generic.ConfirmOverlapingPeriods" };
      this.modalService.showModals([baseModal]).subscribe(result => {
        if (result)
          super.onEdit(isEdit);
      });
    }
    else
      super.onEdit(isEdit);

  }

  onRemove(isEdit: boolean) {
    super.markTouched

    if (this.isVersion2()) {
      if (this.origin === 'AC') {
        var baseModal = <models.BaseModalVM>{ isError: false, message: "Períodos caracterizados como Antigo Combatente não podem ser removidos" };
        this.modalService.showModals([baseModal]).subscribe(result => {
          if (result)
            return;
        });
      } else {
        super.onRemove(isEdit);
      }
    } else {
      super.onRemove(isEdit);
    }
  }

  bonusInDaysFlagChange() {
    this.bonusInDays = false;
  }

  hasOverlapingDates(): boolean {
    var overlapItemIndex = this.itemList.filter((x,index) => index != (this.isEdit ? this.editIndex : -1)).findIndex(effectivity =>
      (this.item.startDate <= effectivity.endDate && this.item.startDate >= effectivity.startDate) || (this.item.endDate <= effectivity.endDate && this.item.endDate >= effectivity.startDate)
     );
    return overlapItemIndex != -1;
  }

  changedWorkHours(value) {
    if(this.item.scheduleTypeCode && (this.item.scheduleTypeCode != 'PS' && this.item.scheduleTypeCode != 'PD')) this.item.effectiveWorkHours = value;
  }

  changedScheduleType(value) {
    if (this.isVersion2())
      if (this.item.scheduleTypeCode && (this.item.scheduleTypeCode != 'PS' && this.item.scheduleTypeCode != 'PD')) this.item.effectiveWorkHours = undefined;
    else
      if (this.item.scheduleTypeCode && (this.item.scheduleTypeCode != 'PS' && this.item.scheduleTypeCode != 'PD')) this.item.effectiveWorkHours = this.item.workHours;
  }

  timeIncreaseOnChange(value) {
    if (value.toString() === 'false' && this.origin === 'AC') {
      this.item.hasIncreasePercentage = this.item.timeIncrease;
    }
  }

  getEntities() {
    let result = [];
    let lastEntity = {};
    for (let i = 0; i < this.parent['workflowDropdowns'].options.length; i++) {
      if (this.parent['workflowDropdowns'].options[i]['dropdown'] === 'dropListEntity') {
        if (this.parent['workflowDropdowns'].options[i]['value'] === 'OUTRA') {
          lastEntity = this.parent['workflowDropdowns'].options[i];
          continue;
        }
        result.push(this.parent['workflowDropdowns'].options[i]);
      }
    }
    result.push(lastEntity);
    result = [...new Map(result.map(item => [item['type'], item])).values()];
    return result;
  }

  getAllowancePlans() {
    let result = [];
    for (let i = 0; i < this.parent['workflowDropdowns'].options.length; i++) {
      if (this.parent['workflowDropdowns'].options[i]['dropdown'] === 'dropListRegAbono') {
        result.push(this.parent['workflowDropdowns'].options[i]);
        result[result.length - 1]['value'] = result[result.length - 1]['description'];
      }
    }
    return result;
  }

  getBonus() {
    //Buscar valores das dropdowns
    let processingDates: any[] = [];
    for (let i = 0; i < this.parent['workflowDropdowns']?.options?.length; i++) {
      if (this.parent['workflowDropdowns'].options[i]['dropdown'] === 'dropListBonification') {
        processingDates.push(this.parent['workflowDropdowns'].options[i]);
      }
      if (this.parent['workflowDropdowns'].options[i]['dropdown'] === 'dropListBonificationDescription') {
        this.bonusDescriptions.push(this.parent['workflowDropdowns'].options[i]);
      }
    }
    
    //filtrar duplicados
    this.bonusDescriptions = [...new Map(this.bonusDescriptions.map(item => [item['description'], item])).values()]

    //filtrar por bonus que estavam ativos na data de início do período
    this.bonusList = processingDates.filter((bonus) => this.item?.startDate && bonus &&
      (!bonus['filter'] || bonus['filter'].getTime() <= this.item.startDate.getTime()) &&
      (!bonus['filter2'] || bonus['filter2'].getTime() >= this.item.startDate.getTime())
    )
  }

  bonusOnChange(bonusCode) {
    //get description
    if (!bonusCode) {
      this.item.bonusDescription = undefined;
      this.bonusInDays = false;
      this.item.numberOfDays = undefined;
      return;
    }

    this.item.bonusDescription = this.bonusDescriptions.filter(b => b.value === bonusCode)[0]?.['description'];
    for (let i = 0; i < this.bonusList.length; i++) {
      if (this.item.bonus.toString() === this.bonusList[i].value) {
        this.percentageController();
        if (this.bonusList[i]['type'] === "D") {
          this.bonusInDays = true;
          this.item.percentage = undefined;
        } else {
          this.bonusInDays = false;
          this.item.numberOfDays = undefined;
        }
        if (this.bonusList[i]['filter4'] === "S") {
          this.bonusWithQuota = true;
        } else if (this.bonusList[i]['filter4'] === "N") {
          this.bonusWithQuota = false;
        }
        break;
      }
    }
  }

  percentageController() {
    for (let j = 0; j < this.bonusList.length; j++) {
      if (this.item.bonus.toString() === this.bonusList[j].value) {
        if (this.item.timeIncrease)
          this.item.percentage = parseFloat(this.bonusList[j]['filter3']);
          break;
      }
    }
  }

  getSubscriberSituations() {
    let result = [];
    if (this.item['entityCode'] !== undefined) {
      let selectedEntity;
      for (let i = 0; i < this.entities.length; i++) {
        if (this.entities[i]['type'] === this.item.entityCode) {
          selectedEntity = this.entities[i];
        }
      }

      for (let i = 0; i < this.parent['workflowDropdowns'].options.length; i++) {
        if (this.parent['workflowDropdowns'].options[i]['dropdown'] === 'dropListPeriodCar') {
          if (!this.parent['workflowDropdowns'].options[i].hasOwnProperty('type') || this.parent['workflowDropdowns'].options[i]['type'] === selectedEntity['type'])
            result.push(this.parent['workflowDropdowns'].options[i]);
        }
      }
    }
    return result;
  }

  changedEntity() {
    if (this.item.entityCode !== undefined) {
      for (let i = 0; i < this.entities.length; i++) {
        switch (this.item.entityCode) {
          case this.entities[i].type:
            this.item.entity = this.entities[i].description;
            break;
          case this.entities[i].value:
            this.item.entity = this.entities[i].description;
            this.item.entityCode = this.entities[i].type;
            break;
          default:
        }
      }
    } else {
      this.item.entity = undefined;
    }

    this.getSubscriberSituations();
  }

  changedInterpolatedWorkHours() {
    if (this.item.interpolatedWorkHours !== undefined)
      this.interpolatedWorkHoursFilled = true;
    else
      this.interpolatedWorkHoursFilled = false;
  }

  isCTorICE() {
    return this.origin === 'CT' || this.origin === 'ICE';
  }

  getStaticBreaks() {
    for (let i = 0; i < this.parent['workflowDropdowns'].options.length; i++) {
      if (this.parent['workflowDropdowns'].options[i]['dropdown'] === 'dropListMapBreak') {
        let breakEntity = {
          value: this.parent['workflowDropdowns'].options[i].value,
          type: this.parent['workflowDropdowns'].options[i].type,
          description: this.parent['workflowDropdowns'].options[i].description
        }

        this.breakList.push(breakEntity);
      }
    }
  }

  getDynamicBreaks() {
    let retirementTaxStartDate;
    let survivalTaxStartDate;
    let paymentStartDate;
    let dateOfBirth55;
    let dateOfBirthEnd60;
    let dateOfBirth65;
    let dataCessacao;

    let step;
    if (this.checkSteps()) {
      step = "StepSubscriberCGA";
    } else {
      step = "StepSubscriberInfo";
    }

    let dateOfBirth = new Date(this.parent['parentWorkflow'].workflowInstance.formData['StepSubscriberInfo']['SubscriberIdentification']?.dateOfBirth);

    retirementTaxStartDate = {
      value: new Date(this.parent['parentWorkflow'].workflowInstance.formData[step]['CGAPensionStatus']?.retirementTaxStartDate),
      type: "INI",
      description: "Data inscrição CGA"
    };
    survivalTaxStartDate = {
      value: new Date(this.parent['parentWorkflow'].workflowInstance.formData[step]['CGAPensionStatus']?.survivalTaxStartDate),
      type: "INI",
      description: "Data inscrição MSE"
    };
    paymentStartDate = {
      value: new Date(this.parent['parentWorkflow'].workflowInstance.formData[step]['CGAPensionStatus']?.paymentStartDate),
      type: "INI",
      description: "Data inscrição DL 24046"
    };
    dateOfBirth55 = {
      value: new Date(dateOfBirth.getFullYear() + 55, dateOfBirth.getMonth(), dateOfBirth.getDate()),
      type: "END",
      description: "Data em que o subscritor completa 55 anos"
    };
    dateOfBirthEnd60 = {
      value: new Date(dateOfBirth.getFullYear() + 61, dateOfBirth.getMonth(), dateOfBirth.getDate() - 1),
      type: "END",
      description: "Data em que o subscritor completa 61 anos - 1 dia"
    };
    dateOfBirth65 = {
      value: new Date(dateOfBirth.getFullYear() + 65, dateOfBirth.getMonth(), dateOfBirth.getDate()),
      type: "END",
      description: "Data em que o subscritor completa 65 anos"
    };
    dataCessacao = {
      value: new Date(this.parent['parentWorkflow'].workflowInstance.formData[step]['CGAPensionStatus']?.dataCessacao),
      type: "END",
      description: "Data de Cessacao"
    };

    let dynamicBreaks = [retirementTaxStartDate, survivalTaxStartDate, paymentStartDate, dateOfBirth55, dateOfBirthEnd60, dateOfBirth65, dataCessacao]
    for (let i = 0; i < dynamicBreaks.length; i++) {
      this.breakList.push(dynamicBreaks[i]);
    }
  }

  sortBreaks() {
    for (let i = 0; i < this.breakList.length; i++) {
      if (this.breakList[i]['value'] !== undefined) {
        if (this.breakList[i]['type'] === 'INI') {
          this.breakList[i]['value'].setHours(0);
          this.breakList[i]['value'].setMinutes(0);
          this.breakList[i]['value'].setSeconds(0);
        } else if (this.breakList[i]['type'] === 'END') {
          this.breakList[i]['value'].setHours(23);
          this.breakList[i]['value'].setMinutes(59);
          this.breakList[i]['value'].setSeconds(59);
        }
      }
    }
    this.breakList.sort((a, b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    var object

    switch (event.target.name) {
      case 'startDate': {
        object = new Date(this.item.startDate).toISOString().split('T')[0]
        break;
      }
      case 'endDate': {
        object = new Date(this.item.endDate).toISOString().split('T')[0];
        break;
      }
    }
    
    DateHelpers.onDateChange(event, dp, object);
  }

  getStartMinEndDate() {
    if (isNullOrUndefined(this.item.endDate))
      return this.maxDate;
    else {

      var minEndDate = new Date(this.maxDate < this.item.endDate ? this.maxDate : this.item.endDate);

      return minEndDate;
    }
  }
}
